import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import auth from './auth'
import errors from './errors'
import loading from './loading'
import messages from './messages'
import notifications from './notifications'
import password from './password'
import routing from './routing'
import scenarios from './scenarios'
import signup from './signup'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    errors,
    loading,
    messages,
    notifications,
    password,
    routing,
    scenarios,
    signup
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js